import { nativeApp } from "./native-app.js";
// Wrapper for axios

import axios from "axios";
import Pace from "pace-js-amd-fix";

class Api {
	constructor() {
		const environment = nativeApp?.environment || ((location.hostname === "localhost" || location.hostname === "127.0.0.1")
			? "development"
			: "production");

		const url = nativeApp?.apiBaseUrl || ((environment == "development")
			? "https://localhost:55009/v1/"
			: "https://order.api.tapapos.com/v1/");

		// Preserve the live search index for local web development; native apps may override it.
		const searchUrl = nativeApp?.searchBaseUrl || "https://search.api.tapapos.com/";

		const service = axios.create({
			baseURL: url,
			timeout: (environment == "development") ? 60 * 1000 : 20 * 1000,
		});

		// interceptors
		var numberOfAjaxCallPending = 0;

		service.interceptors.request.use(
			function (config) {
				numberOfAjaxCallPending++;
				Pace.start();

				return config;
			},
			function (error) {
				return Promise.reject(error);
			},
		);

		service.interceptors.response.use(
			function (response) {
				numberOfAjaxCallPending--;

				if (numberOfAjaxCallPending == 0) {
					Pace.stop();
				}
				return response;
			},
			function (error) {
				numberOfAjaxCallPending--;
				if (numberOfAjaxCallPending == 0) {
					Pace.stop();
				}
				return Promise.reject(error);
			},
		);

		this.environment = environment;
		this.service = service;
		this.baseUrl = url;
		this.searchUrl = searchUrl;
	}

	get(url, timeout, responseType) {
		return this.service({
			method: "get",
			url,
			timeout: timeout,
			responseType: responseType,
		})
			.then((response) => Promise.resolve(response.data))
			.catch((error) => Promise.reject(error));
	}

	post(url, request, timeout, responseType) {
		return this.service({
			method: "post",
			url,
			data: request,
			timeout: timeout,
			responseType: responseType,
		})
			.then((response) => Promise.resolve(response.data))
			.catch((error) => Promise.reject(error));
	}

	put(url, request, timeout, responseType) {
		return this.service({
			method: "put",
			url,
			data: request,
			timeout: timeout,
			responseType: responseType,
		})
			.then((response) => Promise.resolve(response.data))
			.catch((error) => Promise.reject(error));
	}

	delete(url, request) {
		return this.service({
			method: "delete",
			url,
			data: request,
		})
			.then((response) => Promise.resolve(response.data))
			.catch((error) => Promise.reject(error));
	}
}

export default new Api();